import Eastern7Attic1 from '../Eastern/Grand Eastern 7 Attic (1).webp'
import Eastern7Attic2 from '../Eastern/Grand Eastern 7 Attic (2).webp'


const Eastern7Atticimages =[
Eastern7Attic1,Eastern7Attic2
]

export default Eastern7Atticimages;